export const DEFAULT_ROWS_PER_PAGE = 10;
export const PACKAGES = 'packages';

export const NEW_ADMIN_DEFAULT_ORG_NAME = 'SoftPro';
